import { cx } from '@orn/shared-web/utils/cx';

import type { FlagTone, IFlag } from './accountDetailView';

export const BADGE_CLASS = 'inline-flex items-center px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wider';

const TONE_CLASS: Record<FlagTone, string> = {
  warning: 'bg-warning-primary text-fg-warning-primary',
  muted: 'bg-bg-tertiary text-fg-tertiary',
};

interface IFlagBadgesProps {
  flags: readonly IFlag[];
}

/** A wrapping run of data-quality badges; renders nothing when there are none. */
const FlagBadges = ({ flags }: IFlagBadgesProps) => {
  if (flags.length === 0) {
    return null;
  }
  return (
    <span className="flex flex-wrap items-center gap-1">
      {flags.map((flag) => (
        <span key={flag.label} className={cx(BADGE_CLASS, 'whitespace-nowrap', TONE_CLASS[flag.tone])}>
          {flag.label}
        </span>
      ))}
    </span>
  );
};

export default FlagBadges;
